import React from "react";
import { ChevronRightIcon, GiftIcon } from "lucide-react";
import { BONUS_IMAGES, BONUSES } from "../data/content";
interface BonusCarouselProps {
  onSelect: () => void;
}
export function BonusCarousel({
  onSelect
}: BonusCarouselProps) {
  return <div className="-mx-5" data-id="element-81" data-mp="19d06kqst835f">
      <div className="flex snap-x snap-mandatory gap-3 overflow-x-auto px-5 pb-3" style={{
      scrollbarWidth: "none"
    }} aria-label="Bonos incluidos, desliza para ver más" data-id="element-82" data-mp="1e5kz7ozzca7d">
        {BONUSES.map((bonus, i) => {
        const image = BONUS_IMAGES[i];
        return <button key={bonus.title} type="button" onClick={onSelect} className="w-[78%] shrink-0 snap-center overflow-hidden rounded-2xl border border-[#d4ff00]/25 bg-black/65 text-left shadow-xl" aria-label={`Ver oferta con el bono: ${bonus.title}`} data-id="element-83" data-mp="1t3decg1m6wl1" data-mpi={i}>
              {image ? <div className="relative h-36 overflow-hidden border-b border-white/10" data-id="element-84" data-mp="2sqvwmxx0ryx">
                  <img src={image} alt={`Bono: ${bonus.title}`} className="h-full w-full object-cover object-top" data-id="element-85" data-mp="3g7fesgrhda83" />
                  <span className="absolute right-2 top-2 rounded-full bg-[#d4ff00] px-2 py-1 text-[10px] font-extrabold uppercase text-black" data-id="element-86" data-mp="36gt8xe9kfy2l">
                    Gratis hoy
                  </span>
                </div> : <div className="flex h-20 items-center justify-center border-b border-white/10 bg-[#d4ff00]/10" data-id="element-87" data-mp="3u65c9xi7pbwz">
                  <GiftIcon className="h-8 w-8 text-[#d4ff00]" data-id="element-88" data-mp="3p69i0pzbgyum" />
                </div>}
              <div className="p-4" data-id="element-89" data-mp="3k87qdgntrr7j">
                <div className="flex items-start gap-2" data-id="element-90" data-mp="3k76c73biioll">
                  <span className="text-xl leading-none" data-id="element-91" data-mp="2ds5gmyqeg8fj">{bonus.emoji}</span>
                  <div className="min-w-0 flex-1" data-id="element-92" data-mp="28sj12in3mg3k">
                    <p className="text-[14px] font-extrabold leading-snug text-white" data-id="element-93" data-mp="28rriq9iiiev8">
                      {i + 1}. {bonus.title}
                    </p>
                    <p className="mt-2 text-[12px] leading-relaxed text-white/60" data-id="element-94" data-mp="14ufdt01wyrdu">
                      {bonus.desc}
                    </p>
                  </div>
                </div>
                <div className="mt-3 flex items-center gap-1 text-[11px] font-bold uppercase tracking-wide text-[#d4ff00]" data-id="element-95" data-mp="qxadlgovsmqi">
                  Incluido en tu compra <ChevronRightIcon className="h-3.5 w-3.5" data-id="element-96" data-mp="h41srthqxssr" />
                </div>
              </div>
            </button>;
      })}
      </div>
      <p className="mt-1 text-center text-[11px] text-white/45" data-id="element-97" data-mp="84esjb0r6t1a">Desliza para descubrir los 10 bonos →</p>
    </div>;
}